import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import Config from '../../utils/config.service';

@Component({
	standalone: true,
	selector: 'list-language-flags',
	templateUrl: './list-language-flags.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ListLanguageFlagsComponent implements OnInit {
	private config: Config = inject(Config);
	
	@Input() languages: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.getFlagCss = this.getFlagCss;
	}
	
	getFlagCss(lang) {
		return this.config.getFlagCss(lang);
	}
	
}